.monaco-editor .selection-anchor{background-color:#007acc;width:2px!important}